export default "__VITE_ASSET__BAt6W$Pu__"